export const GRAPHIC_HEIGHT = 320
export const MAX_TAG_QUESTIONS = 30
export const QUESTION_HEIGHT = 6
export const OPACITY = 0.5
export const CONTAINER_P_X = 85
export const CONTAINER_P_Y = 0
export const GRAPHS_DISTANCE = 200
export const GRAPH_WIDTH = 30
